import { axiosInstance } from ".";

const getExpensesList = async (params) =>
  await axiosInstance.get("/expenses", { params });

const addExpense = async (payload) =>
  await axiosInstance.post("/expenses", payload);

const editExpense = async ({id, data}) =>
await axiosInstance.patch(`/expenses/${id}`, data);

const viewExpense = async ({id}) =>
await axiosInstance.get(`/expenses/${id}`);

const deleteExpense = async ({ id }) =>
  await axiosInstance.delete(`/expenses/${id}`);

const getMimarProfit = async (params) =>
  await axiosInstance.get("finances/statistics", { params });

export { getExpensesList, addExpense, editExpense, viewExpense, deleteExpense, getMimarProfit };
